var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_checked",
    transform: "translate(-1608 -84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 16,
    height: 16,
    transform: "translate(1608 84)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    d: "M11.918-9.968,4.725-2.775,2.082-5.418a.328.328,0,0,0-.464,0l-.773.773a.328.328,0,0,0,0,.464L4.493-.532a.328.328,0,0,0,.464,0l8.2-8.2a.328.328,0,0,0,0-.464l-.773-.773A.328.328,0,0,0,11.918-9.968Z",
    transform: "translate(1609 97)",
    fill: "#a0a3c4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic_checked.ef61d0e2387a284508c166ceb400db63.svg";
export { ForwardRef as ReactComponent };